<mat-card style="border-color: #5775a8;">


  <mat-card-content>
    <div class="flex flex-col w-full" style="overflow-x:auto;">
      <span style="font-size:large;;padding-top: 25px;">
        <b>Add files only at the direction of OHA.</b>
      </span>
      <hr style="border: 1px solid gray;">
      <br />
      <form [formGroup]="form">
        <div>
          <mat-form-field class="container">
            <mat-label>Name</mat-label>
            <input matInput matTooltip="(Optional)" formControlName="name">
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="container">
            <mat-label>Description</mat-label>
            <textarea matInput cdkTextareaAutosize formControlName="description" matTooltip="(Optional)"></textarea>
            <!-- <input matInput matTooltip="(Optional)" formControlName="description"> -->
          </mat-form-field>
        </div>
        <br />

        <div>
          <input type="file" class="file-input" (change)="uploadFile($event)"
            accept=".gif, .jpg, .jepg, .png, .bmp, .pdf" hidden="true" #csvFileUpload1>
          <button mat-raised-button class="m-8" color="accent" (click)="csvFileUpload1.click()">
            <mat-icon>attach_file</mat-icon>Add File: <span style="color:red;">* Required</span>
          </button>
          <div>{{fileName}}</div>
        </div>
        <span style="color: brown;">File size limit: 4 MB</span>
        <hr style="border: 1px solid gray;">
        <br />
        <div class="flex flex-row w-full">
          <div style="padding-right: 20px;padding-left:10px;">
            <button mat-raised-button (click)="close()" style="padding-right: 20px;">
              Close
            </button>
          </div>
          <div>
            <button mat-raised-button (click)="addFile()" style="background: #7ABDF3;">
              <mat-icon>add</mat-icon> Add File
            </button>
          </div>
        </div>
      </form>
    </div>
  </mat-card-content>

</mat-card>